import { describeFields, FieldWidget } from '../common/fields';
import { UserNoteSchema } from './schemas';

export const USER_NOTE_FIELDS = describeFields(UserNoteSchema, {
  id: {},
  ownerId: {},
  creationDatetime: { widget: FieldWidget.DateTime },
  lastEditDatetime: { widget: FieldWidget.DateTime },
  priorityDatetime: { widget: FieldWidget.DateTime },
  dueDatetime: { widget: FieldWidget.DateTime },
  note: { widget: FieldWidget.LongText },
  createdBy: {},
  createdBySystem: {},
  creatorName: {},
  assigneeId: {},
  assigneeName: {},
  active: { widget: FieldWidget.Text },
  billingRelated: { widget: FieldWidget.Text },
});
